import { render } from "./NotaSpesaDetail.vue?vue&type=template&id=3acea4a2&scoped=true"
import script from "./NotaSpesaDetail.vue?vue&type=script&lang=js"
export * from "./NotaSpesaDetail.vue?vue&type=script&lang=js"

import "./NotaSpesaDetail.vue?vue&type=style&index=0&id=3acea4a2&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acea4a2"]])

export default __exports__